import { securityQuestionActionTypes } from './../constants/ApiConstants';

const initialState = {
  loading: false,
  getSecurityQuestions: null,
  postSecurityQuestion: null,
  getSecurityQuestionById: null,
  deleteSecurityQuestion: null,
};
export default (state = initialState, { type, payload }) => {
  switch (type) {
  case securityQuestionActionTypes.get_security_question.REQUEST:
    return {
      ...state,
      loading: true,
      getSecurityQuestions: null,
    };
  case securityQuestionActionTypes.post_security_question.REQUEST:
    return {
      ...state,
      loading: true,
      postSecurityQuestion: null,
    };
  case securityQuestionActionTypes.get_security_question.SUCCESS:
    return {
      ...state,
      loading: false,
      getSecurityQuestions: payload,
    };
  case securityQuestionActionTypes.post_security_question.SUCCESS:
    return {
      ...state,
      loading: false,
      postSecurityQuestion: payload,
    };
  case securityQuestionActionTypes.get_security_question.FAILURE:
    return {
      ...state,
      loading: false,
    };
  case securityQuestionActionTypes.delete_security_question.REQUEST:
    return {
      ...state,
      loading: true,
      deleteSecurityQuestion: null,
    };
  case securityQuestionActionTypes.delete_security_question.SUCCESS:
    return {
      ...state,
      deleteSecurityQuestion: payload,
      loading: false,
    };
  case securityQuestionActionTypes.get_security_question_by_id.REQUEST:
    return {
      ...state,
      loading: true,
      getSecurityQuestionById: null,
    };
  case securityQuestionActionTypes.get_security_question_by_id.SUCCESS:
    return {
      ...state,
      loading: false,
      getSecurityQuestionById: payload,
    };
  default:
    return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/Masters/components/securityQuestions/reducers/SecurityQuestionReducers.js